export default function auth({ next }) {
    // if(!store.getters.auth.loggedIn){
    if (!window.localStorage.getItem("rep")) {
        return next({
            name: 'auth'
        })
    }

    return next()
}